let width = window.innerWidth;
let breakpoint = 1024;
const introJs = window.introJs;
if (typeof introJs !== 'function') {
    throw new Error('introJs is not available on window.');
}

let intro = introJs();
let steps = [];
let is_mobile = width < breakpoint;
fetch('/wp-json/base/v1/new-site-tour')
    .then(res=>res.json())
    .then(data=>{
        
        if( typeof data.steps !== 'undefined' && data.steps.length){
            for (let i = 0; i < data.steps.length; i++) {
                let step_data = data.steps[i];
                let element = false;
                
                let has_mobile_selector = step_data.selector_mobile.length;
                let has_desktop_selector = step_data.selector.length;
                
                let mobile_only = has_mobile_selector && ! has_desktop_selector;
                let desktop_only = has_desktop_selector && ! has_mobile_selector;

                
                if(is_mobile && desktop_only || ! is_mobile && mobile_only) {
                    continue;
                }

                if (is_mobile && step_data.selector_mobile.length) {
                    element = {
                        type: 'mobile',
                        selector : step_data.selector_mobile
                    }
                } else if (!is_mobile && step_data.selector.length) {
                    element = {
                        type: 'desktop',
                        selector : step_data.selector
                    }
                }
                let step = {
                    title : step_data.title,
                    intro: step_data.message
                }
                
                if (
                    element && element.selector.length &&
                    document.querySelector(element.selector) !== null
                ) {
                   step.element = document.querySelector(element.selector);
                }
                
                if (
                    ! element || 
                    is_mobile && element.type === 'mobile' ||
                    ! is_mobile && element.type === 'desktop'
                ) {
                    steps.push(step);
                }
                
                
            }
            
            intro.setOptions({
                steps: steps
            });
            // console.log(intro);
            intro.onbeforechange(function(){
                let overlays = document.getElementsByClassName('introjs-overlay');
                for(var i = 0; i<overlays.length; i++) {
                    overlays[i].setAttribute('role','button');
                    overlays[i].setAttribute('aria-label','Close Tour');
                }

                
            })
            
            .onbeforeexit(function(){
                //setup cookie string
                let today = new Date();
                let expires = new Date();
                expires.setDate(today.getDate()+365);
                
                setCookie('disable_product_tour','true',365);
            })
            .start(); 
        }
    })

    function setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        let expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/;secure";
      }
